import { lazy } from 'react';

import type { RouteObject } from 'react-router-dom';
import { Route, Routes } from 'react-router-dom';

import NotFoundPage from '@packages/core/pages/not-found-v2/not-found-v2.page';
import { useFeatureFlag } from '@packages/platform/feature-flags/use-feature-flag';
import {
  THREAT_INTEL_SKU_BULLETIN_RELATIVE_PATH,
  THREAT_INTEL_SKU_BULLETINS_RELATIVE_PATH,
  THREAT_INTEL_SKU_ROUTE,
} from 'ae-constants/routes.constants';

const BulletinListPage = lazy(
  () => import('./bulletin-list/bulletin-list.page'),
);

const BulletinDetailsPage = lazy(
  () => import('./bulletin-details/bulletin-details.page'),
);

const ThreatIntelSkuRoutes = () => {
  const [skuFF] = useFeatureFlag('THREAT_INTEL_SKU');

  if (!skuFF) {
    return (
      <Routes>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route
        path={THREAT_INTEL_SKU_BULLETINS_RELATIVE_PATH}
        index
        element={<BulletinListPage />}
      />
      <Route
        path={THREAT_INTEL_SKU_BULLETIN_RELATIVE_PATH}
        element={<BulletinDetailsPage />}
      />
    </Routes>
  );
};

export const threatIntelSkuRoutes: RouteObject = {
  element: <ThreatIntelSkuRoutes />,
  path: `${THREAT_INTEL_SKU_ROUTE}/*`,
};
